(() => {
  // Debug: window.KMR_ISW_HIDE_ZERO_DEBUG = true
  const DEBUG = () => window.KMR_ISW_HIDE_ZERO_DEBUG === true;
  const log = (...a) => DEBUG() && console.log("[KMR ISW HIDE ZERO]", ...a);

  // Toggle POA hiding (default true)
  const HIDE_POA = true;

  // Prevent double-load
  if (window.__KMR_ISW_HIDE_ZERO_LOADED__) return;
  window.__KMR_ISW_HIDE_ZERO_LOADED__ = true;

  const UL_SELECTOR =
    ".boost-sd__search-widget-init-wrapper .boost-sd__instant-search-column--products ul.boost-sd__instant-search-product-list-items";

  const CARD_SELECTOR = "li.boost-sd__suggestion-queries-item--product";

  const POA_RE = /\bp\.?\s*o\.?\s*a\b/i;

  const decodeHtml = (str) => {
    if (!str) return "";
    const t = document.createElement("textarea");
    t.innerHTML = str;
    return t.value;
  };

  const getCardPOA = (card) => {
    // Look for POA in the product-right/text area first
    const right =
      card.querySelector(".boost-sd__suggestion-queries-item-product-right") || card;

    const txt = (right.textContent || "").replace(/\s+/g, " ").trim();
    return POA_RE.test(txt) || txt.toUpperCase().includes("P.O.A");
  };

  const getCardPriceNumber = (card) => {
    // 1) Prefer Boost's embedded JSON on a child node
    const prodEl = card.querySelector("[data-product]");
    const raw = prodEl?.getAttribute("data-product");
    if (raw) {
      try {
        const jsonStr = decodeHtml(raw).trim();
        const p = JSON.parse(jsonStr);

        // Try common fields Boost/feeds use
        const v =
          p?.priceMin ??
          p?.price ??
          p?.price_min ??
          p?.price_minimum ??
          p?.priceMax ??
          null;

        if (v === null || v === undefined) return null;

        // If it comes through as a string, strip currency etc.
        const n = parseFloat(String(v).replace(/[^0-9.]/g, ""));
        return Number.isFinite(n) ? n : null;
      } catch (_) {
        // fall through
      }
    }

    // 2) Fallback: parse visible price text (if present)
    const priceCandidates = [
      card.querySelector(".boost-sd__suggestion-queries-item-product-price"),
      card.querySelector("[class*='price']"),
      card.querySelector(".money"),
    ].filter(Boolean);

    for (const el of priceCandidates) {
      const txt = (el.textContent || "").trim();
      if (!txt) continue;
      if (POA_RE.test(txt) || txt.toUpperCase().includes("P.O.A")) return null;

      const m = txt.replace(/,/g, "").match(/(\d+(\.\d+)?)/);
      if (!m) continue;

      const n = parseFloat(m[1]);
      if (Number.isFinite(n)) return n;
    }

    return null;
  };

  const getUL = () => document.querySelector(UL_SELECTOR);

  const filter = () => {
    const ul = getUL();
    if (!ul) return;

    const cards = Array.from(ul.querySelectorAll(CARD_SELECTOR));
    if (!cards.length) return;

    let hiddenZero = 0;
    let hiddenPoa = 0;

    cards.forEach((card) => {
      // Don’t hide anything that *you* injected for promos, if any
      if (card.classList.contains("kmr-isw-promo-banner-li")) return;

      const isPoa = HIDE_POA && getCardPOA(card);
      const price = getCardPriceNumber(card);

      const shouldHide = isPoa || (price !== null && price <= 0);

      if (shouldHide) {
        if (card.getAttribute("data-kmr-zero-hidden") !== "1") {
          card.style.setProperty("display", "none", "important");
          card.setAttribute("data-kmr-zero-hidden", "1");
        }
        if (isPoa) hiddenPoa++;
        else hiddenZero++;
      } else {
        if (card.getAttribute("data-kmr-zero-hidden") === "1") {
          card.style.removeProperty("display");
          card.removeAttribute("data-kmr-zero-hidden");
        }
      }
    });

    log("Filtered", { total: cards.length, hiddenZero, hiddenPoa });
  };

  const debounce = (fn, ms = 120) => {
    let t;
    return () => {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  };

  const run = debounce(filter, 120);

  // Observe rerenders inside ISW wrapper only (lower cost than whole body)
  const target = document.querySelector(".boost-sd__search-widget-init-wrapper") || document.body;
  const mo = new MutationObserver(run);
  mo.observe(target, { childList: true, subtree: true });

  // Typing triggers ISW changes
  document.addEventListener("input", run, true);

  // Manual hook
  window.KMR_ISW_HIDE_ZERO_APPLY = filter;

  // Initial
  run();
})();
